module.exports = __webpack_public_path__ + "img/laptop.bf371251.png";